import { Box } from '@material-ui/core'
import DescriptionIcon from '@material-ui/icons/Description'

import {
  ChildrenDocument,
  ChildrenDocumentAttachment,
  ChildrenDocumentMissing,
  FOLDER_NAME_TO_CATEGORY,
} from '../../models/document'
import { midGray } from '../../theme/colors'
import { FlexBox } from '../Base/FlexBox'
import { Text } from '../Text/Text'
import { DocumentListGrid } from './DocumentList'
import { DocumentRowAttachmentsVersionItem } from './DocumentRowAttachmentsVersionItem'

interface DocumentRowAttachmentsItemProps {
  document: ChildrenDocument | ChildrenDocumentMissing
  onDocumentOpen?: (
    document: ChildrenDocument | ChildrenDocumentMissing,
    attachments?: ChildrenDocumentAttachment[]
  ) => React.ReactNode
  renderDocumentAction?: (
    document: ChildrenDocument | ChildrenDocumentMissing,
    attachments?: ChildrenDocumentAttachment[],
    refetchDocuments?: () => Promise<any>
  ) => React.ReactNode
}

export function DocumentRowAttachmentsItem({
  document,
  onDocumentOpen,
  renderDocumentAction,
}: DocumentRowAttachmentsItemProps) {
  function renderAttachments() {
    if ('documentAttachmentVersions' in document) {
      return document.documentAttachmentVersions.map((attachments) => {
        return (
          <DocumentRowAttachmentsVersionItem
            key={attachments ? attachments[0].id : document.id}
            document={document}
            attachments={attachments}
            onDocumentOpen={onDocumentOpen}
            renderDocumentAction={renderDocumentAction}
          />
        )
      })
    }
  }

  return (
    <>
      <DocumentListGrid isItem>
        <FlexBox gap="5px">
          <Box mt={-0.2}>
            <DescriptionIcon color="primary" />
          </Box>
          <Text variant="label2" fontColor={midGray}>
            {document.documentName}
          </Text>
        </FlexBox>

        <div></div>
        <div></div>
        <div></div>

        <Text variant="paragraph1" fontColor={midGray}>
          {FOLDER_NAME_TO_CATEGORY[document.folderName]}
        </Text>

        <div></div>
      </DocumentListGrid>

      {renderAttachments()}
    </>
  )
}
